export const librariesList = ['geometry', 'drawing', 'places'] as (
  | 'geometry'
  | 'drawing'
  | 'places'
  | 'localContext'
  | 'visualization'
)[];
